import { render, staticRenderFns } from "./SfDivider.vue?vue&type=template&id=19ec3b2e&functional=true"
import script from "./SfDivider.vue?vue&type=script&lang=js"
export * from "./SfDivider.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfDivider.vue?vue&type=style&index=0&id=19ec3b2e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "01528315"
  
)

export default component.exports